import { Alert, Platform } from 'react-native'
import { showErrorToast, showSuccessToast } from '@utils'

// Alert.alert does nothing on the website (react-native-web ships an empty
// one), so the import screens gave no feedback there. The website shows the
// app's usual banner; phones keep their dialog.
export const notify = (kind: 'success' | 'error', title: string, message?: string) => {
  if (Platform.OS !== 'web') {
    Alert.alert(title, message)
    return
  }
  if (kind === 'success') showSuccessToast(title, message)
  else showErrorToast(title, message)
}
